<template>
  <el-upload
    action="/channelClient/upload"
    :data="{ dir: dir }"
    :file-list="fileList"
    :on-remove="onChange"
    :on-change="onChange"
    :on-preview="preview"
    accept=".pdf"
  >
    <el-button size="mini" type="primary" plain>upload</el-button>
  </el-upload>
</template>

<script>
export default {
	data() {
		return {
			fileList: [],
		};
	},
	props: {
		value: {},
		dir: { type: String, required: true },
		afterChange: Function,
	},
	mounted() {
		this.watchValue(this.value);
	},
	watch: {
		value: function (newV) {
			this.watchValue(newV);
		},
	},

	methods: {
		watchValue(newV) {
			if (newV) {
				const v = JSON.parse(newV);
				if (Array.isArray(v)) {
					this.fileList = v.map((row) => {
						return {
							name: row.file_name,
							response: row,
						};
					});
				} else {
					this.fileList = [{ name: v.file_name, response: v }];
				}
			}else{
				this.fileList = [];
			}
		},
		onChange(files, fileList) {
			this.fileList = fileList;
			this.$emit(
				"input",
				JSON.stringify(this.fileList.map((row) => row.response))
			);
			if (this.afterChange) {
				this.afterChange();
			}
		},
		preview(file) {
			window.open(`/preview?file=${file.response.file_path}`);
		},
	},
};
</script>
